const priceByQuantity = (product, qtyCart) => {
  if (qtyCart == 0) return product.min_price || product.price

  if (product?.prices_current?.length > 1) {
    // Tri des paliers par ordre croissant
    const sortedPrices = [...product.prices_current].sort((a, b) => Number(a.mini) - Number(b.mini))

    const priceSelect = sortedPrices.find((o, index) => {
      // Pour le dernier palier, on vérifie seulement le mini
      if (index === sortedPrices.length - 1) {
        return qtyCart >= Number(o.mini)
      }
      // Pour les autres paliers, on vérifie mini et maxi
      return qtyCart >= Number(o.mini) && qtyCart <= Number(o.maxi)
    })

    return priceSelect?.price_sales || product.price
  }

  return product.min_price || product.price
}

const getProductPrice = (
  product,
  qtyCart
): {
  price: any
  crossedOutPrice: any
  percent: any
  isPromotion: boolean
  promotionLimited: any
} => {
  const min_price = priceByQuantity(product, qtyCart)

  const base_price =
    parseFloat(product.base_price) != parseFloat(min_price) ? product.base_price : 0

  const crossedOutPrice = parseFloat(product.list_price) || parseFloat(base_price)

  //3400930174227 KRK on a pas la remise !!!!
  const percent_discount_calc_by_price = crossedOutPrice
    ? (100 - (min_price * 100) / crossedOutPrice).toFixed(1)
    : 0

  const percent_discount =
    min_price != product.min_price || !Number(product?.percent_discount)
      ? percent_discount_calc_by_price
      : product.percent_discount

  const isPromotion = percent_discount > 0
  const promotionLimited = product.promotions_current?.find(p => !p.is_unlimited)

  const percent = product.percent_discount_decimal ? percent_discount : Math.round(percent_discount)

  return {
    price: min_price,
    crossedOutPrice,
    percent,
    isPromotion,
    promotionLimited,
  }
}

export default getProductPrice
